// ajax请求
import ajaxFn from './ajax';
// 通用工具
import commonUtil from './common-util';
// storage操作
import storage from './storage';
// 格式化数字
import getDid from './did';
import { getAppCsrf, getDYCsrf } from './csrf';
import wxMiniprogram from './miniprogram';
import { getAppToken, appLogin } from './appfn';

export {
    ajaxFn,
    commonUtil,
    storage,
    getDid,
    getAppCsrf,
    getDYCsrf,
    wxMiniprogram,
    getAppToken,
    appLogin
};
